import { userStorage } from '../lib/userStorage';

export const CATEGORY_OPTIONS = ['Safety', 'Target', 'Reach'];
export const CUSTOM_TRACKING_CATEGORY = 'Custom Tracking';
export const CUSTOM_FIELD_CATEGORY = 'Custom Fields';
export const CUSTOM_FIELD_TYPES_WITH_OPTIONS = ['label', 'dropdown'];
export const DEFAULT_CUSTOM_COLUMNS = [
  {
    id: 'custom_scholarship_notes',
    label: 'Scholarship Notes',
    category: CUSTOM_TRACKING_CATEGORY,
    type: 'custom',
    isBuiltIn: true,
    customType: 'text',
    sortable: true,
    sortType: 'string',
  },
  {
    id: 'custom_portal_login',
    label: 'Portal Link',
    category: CUSTOM_TRACKING_CATEGORY,
    type: 'custom',
    isBuiltIn: true,
    customType: 'link',
    sortable: true,
    sortType: 'string',
  },
  {
    id: 'custom_campus_visit',
    label: 'Campus Visit',
    category: CUSTOM_TRACKING_CATEGORY,
    type: 'custom',
    isBuiltIn: true,
    customType: 'label',
    labels: ['Not planned', 'Scheduled', 'Visited'],
    sortable: true,
    sortType: 'string',
  },
];
export const BUILT_IN_CUSTOM_COLUMN_IDS = DEFAULT_CUSTOM_COLUMNS.map((column) => column.id);

const degreeLabels = {
  0: 'Not classified',
  1: 'Certificate',
  2: "Associate's",
  3: "Bachelor's",
  4: 'Graduate',
};

const schoolTypeLabels = {
  1: 'Public',
  2: 'Private nonprofit',
  3: 'Private for-profit',
};

export const COLUMN_OPTIONS = [
  { id: 'checkbox', label: 'Checkbox', category: 'Custom Tracking', type: 'checkbox', sortable: false, keywords: ['done', 'complete'] },
  { id: 'category', label: 'Rank - Safety, Target, Reach', category: 'Custom Tracking', type: 'select', sortable: true, sortType: 'string', keywords: ['category', 'rank', 'reach', 'target', 'safety'] },
  { id: 'date', label: 'Date', category: 'Custom Tracking', type: 'date', sortable: true, sortType: 'string', keywords: ['deadline', 'due'] },

  { id: 'school_name', label: 'School Name', category: 'Basics', type: 'data', apiKey: 'latest.school.name', sortable: true, sortType: 'string' },
  { id: 'school_url', label: 'Website', category: 'Basics', type: 'data', apiKey: 'latest.school.school_url', sortable: true, sortType: 'string', format: 'url', keywords: ['url', 'link'] },
  { id: 'student_size', label: 'Student Size', category: 'Basics', type: 'data', apiKey: 'latest.student.size', sortable: true, sortType: 'number', format: 'integer', keywords: ['enrollment', 'size'] },
  { id: 'school_type', label: 'School Type', category: 'Basics', type: 'data', apiKey: 'latest.school.ownership', sortable: true, sortType: 'number', format: 'schoolType', keywords: ['public', 'private', 'ownership'] },
  { id: 'main_campus', label: 'Main Campus', category: 'Basics', type: 'data', apiKey: 'latest.school.main_campus', sortable: true, sortType: 'number', format: 'yesNo', keywords: ['main', 'branch'] },
  { id: 'online_only', label: 'Online Only', category: 'Basics', type: 'data', apiKey: 'latest.school.online_only', sortable: true, sortType: 'number', format: 'yesNo', keywords: ['online'] },

  { id: 'acceptance_rate', label: 'Acceptance Rate', category: 'Admissions', type: 'data', apiKey: 'latest.admissions.admission_rate.overall', sortable: true, sortType: 'number', format: 'percent', keywords: ['admit', 'admission'] },
  { id: 'sat_average', label: 'SAT Average', category: 'Admissions', type: 'data', apiKey: 'latest.admissions.sat_scores.average.overall', sortable: true, sortType: 'number', format: 'integer' },
  { id: 'sat_range', label: 'SAT Range', category: 'Admissions', type: 'data', apiKeys: ['latest.admissions.sat_scores.25th_percentile.math', 'latest.admissions.sat_scores.25th_percentile.critical_reading', 'latest.admissions.sat_scores.75th_percentile.math', 'latest.admissions.sat_scores.75th_percentile.critical_reading'], sortable: true, sortType: 'number', format: 'satRange', keywords: ['sat 25', 'sat 75'] },
  { id: 'sat_25th', label: 'SAT 25th Percentile', category: 'Admissions', type: 'data', apiKeys: ['latest.admissions.sat_scores.25th_percentile.math', 'latest.admissions.sat_scores.25th_percentile.critical_reading'], sortable: true, sortType: 'number', format: 'satSum' },
  { id: 'sat_75th', label: 'SAT 75th Percentile', category: 'Admissions', type: 'data', apiKeys: ['latest.admissions.sat_scores.75th_percentile.math', 'latest.admissions.sat_scores.75th_percentile.critical_reading'], sortable: true, sortType: 'number', format: 'satSum' },
  { id: 'act_midpoint', label: 'ACT Midpoint', category: 'Admissions', type: 'data', apiKey: 'latest.admissions.act_scores.midpoint.cumulative', sortable: true, sortType: 'number', format: 'number' },
  { id: 'act_range', label: 'ACT Range', category: 'Admissions', type: 'data', apiKeys: ['latest.admissions.act_scores.25th_percentile.cumulative', 'latest.admissions.act_scores.75th_percentile.cumulative'], sortable: true, sortType: 'number', format: 'actRange', keywords: ['act 25', 'act 75'] },
  { id: 'act_english_midpoint', label: 'ACT English Midpoint', category: 'Admissions', type: 'data', apiKey: 'latest.admissions.act_scores.midpoint.english', sortable: true, sortType: 'number', format: 'number' },
  { id: 'act_math_midpoint', label: 'ACT Math Midpoint', category: 'Admissions', type: 'data', apiKey: 'latest.admissions.act_scores.midpoint.math', sortable: true, sortType: 'number', format: 'number' },
  { id: 'test_optional', label: 'Test Optional', category: 'Admissions', type: 'data', apiKey: 'latest.admissions.test_requirements', sortable: true, sortType: 'number', format: 'testOptional', keywords: ['sat optional', 'act optional', 'testing'] },

  { id: 'city', label: 'City', category: 'Location', type: 'data', apiKey: 'latest.school.city', sortable: true, sortType: 'string' },
  { id: 'state', label: 'State', category: 'Location', type: 'data', apiKey: 'latest.school.state', sortable: true, sortType: 'string' },
  { id: 'distance_from_home', label: 'Distance from Home', category: 'Location', type: 'data', apiKeys: ['location.lat', 'location.lon'], sortable: true, sortType: 'number', format: 'distanceFromHome', keywords: ['miles', 'home', 'near me', 'far'] },
  { id: 'zip', label: 'ZIP', category: 'Location', type: 'data', apiKey: 'latest.school.zip', sortable: true, sortType: 'string' },
  { id: 'region', label: 'Region', category: 'Location', type: 'data', apiKey: 'latest.school.region_id', sortable: true, sortType: 'number', format: 'region', keywords: ['northeast', 'south', 'west', 'midwest'] },
  { id: 'campus_setting', label: 'Campus Setting', category: 'Location', type: 'data', apiKey: 'latest.school.locale', sortable: true, sortType: 'number', format: 'locale', keywords: ['city', 'suburb', 'town', 'rural'] },
  { id: 'latitude', label: 'Latitude', category: 'Location', type: 'data', apiKey: 'location.lat', sortable: true, sortType: 'number', format: 'decimal' },
  { id: 'longitude', label: 'Longitude', category: 'Location', type: 'data', apiKey: 'location.lon', sortable: true, sortType: 'number', format: 'decimal' },

  { id: 'cost_in_state', label: 'In-State Tuition', category: 'Cost & Aid', type: 'data', apiKey: 'latest.cost.tuition.in_state', sortable: true, sortType: 'number', format: 'currency' },
  { id: 'cost_out_state', label: 'Out-of-State Tuition', category: 'Cost & Aid', type: 'data', apiKey: 'latest.cost.tuition.out_of_state', sortable: true, sortType: 'number', format: 'currency' },
  { id: 'cost_attendance', label: 'Total Cost', category: 'Cost & Aid', type: 'data', apiKey: 'latest.cost.attendance.academic_year', sortable: true, sortType: 'number', format: 'currency', keywords: ['estimated cost of attendance', 'total cost'] },
  { id: 'room_board_oncampus', label: 'Room & Board', category: 'Cost & Aid', type: 'data', apiKey: 'latest.cost.roomboard.oncampus', sortable: true, sortType: 'number', format: 'currency', keywords: ['housing', 'dorm'] },
  { id: 'books_supplies', label: 'Books & Supplies', category: 'Cost & Aid', type: 'data', apiKey: 'latest.cost.booksupply', sortable: true, sortType: 'number', format: 'currency' },
  { id: 'avg_net_price', label: 'Average Net Price', category: 'Cost & Aid', type: 'data', apiKeys: ['latest.cost.avg_net_price.public', 'latest.cost.avg_net_price.private'], sortable: true, sortType: 'number', format: 'firstCurrency', keywords: ['net cost', 'actual cost'] },
  { id: 'pell_grant_rate', label: 'Pell Grant Rate', category: 'Cost & Aid', type: 'data', apiKey: 'latest.aid.pell_grant_rate', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'federal_loan_rate', label: 'Federal Loan Rate', category: 'Cost & Aid', type: 'data', apiKey: 'latest.aid.federal_loan_rate', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'any_loan_rate', label: 'Any Loan Rate', category: 'Cost & Aid', type: 'data', apiKey: 'latest.aid.students_with_any_loan', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'median_debt', label: 'Median Debt', category: 'Cost & Aid', type: 'data', apiKey: 'latest.aid.median_debt.completers.overall', sortable: true, sortType: 'number', format: 'currency' },

  { id: 'predominant_degree', label: 'Predominant Degree', category: 'Academics', type: 'data', apiKey: 'latest.school.degrees_awarded.predominant', sortable: true, sortType: 'number', format: 'degree' },
  { id: 'highest_degree', label: 'Highest Degree', category: 'Academics', type: 'data', apiKey: 'latest.school.degrees_awarded.highest', sortable: true, sortType: 'number', format: 'degree' },
  { id: 'computer_programs', label: 'Computer Science %', category: 'Academics', type: 'data', apiKey: 'latest.academics.program_percentage.computer', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'engineering_programs', label: 'Engineering %', category: 'Academics', type: 'data', apiKey: 'latest.academics.program_percentage.engineering', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'business_programs', label: 'Business %', category: 'Academics', type: 'data', apiKey: 'latest.academics.program_percentage.business_marketing', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'health_programs', label: 'Health Programs %', category: 'Academics', type: 'data', apiKey: 'latest.academics.program_percentage.health', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'biology_programs', label: 'Biology %', category: 'Academics', type: 'data', apiKey: 'latest.academics.program_percentage.biological', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'psychology_programs', label: 'Psychology %', category: 'Academics', type: 'data', apiKey: 'latest.academics.program_percentage.psychology', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'social_science_programs', label: 'Social Science %', category: 'Academics', type: 'data', apiKey: 'latest.academics.program_percentage.social_science', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'visual_performing_programs', label: 'Visual & Performing Arts %', category: 'Academics', type: 'data', apiKey: 'latest.academics.program_percentage.visual_performing', sortable: true, sortType: 'number', format: 'percent' },

  { id: 'retention_rate', label: 'First-Year Retention', category: 'Outcomes', type: 'data', apiKey: 'latest.student.retention_rate.four_year.full_time', sortable: true, sortType: 'number', format: 'percent', keywords: ['freshman retention'] },
  { id: 'graduation_rate', label: 'Graduation Rate', category: 'Outcomes', type: 'data', apiKey: 'latest.completion.completion_rate_4yr_150nt', sortable: true, sortType: 'number', format: 'percent', keywords: ['completion'] },
  { id: 'transfer_rate', label: 'Transfer-Out Rate', category: 'Outcomes', type: 'data', apiKey: 'latest.completion.transfer_rate.4yr.full_time', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'median_earnings_6yr', label: 'Median Earnings 6 Years', category: 'Outcomes', type: 'data', apiKey: 'latest.earnings.6_yrs_after_entry.median', sortable: true, sortType: 'number', format: 'currency', keywords: ['salary', 'income'] },
  { id: 'median_earnings_10yr', label: 'Median Earnings', category: 'Outcomes', type: 'data', apiKey: 'latest.earnings.10_yrs_after_entry.median', sortable: true, sortType: 'number', format: 'currency', keywords: ['salary', 'income', '10 years'] },

  { id: 'first_gen_share', label: 'First-Gen Share', category: 'Student Body', type: 'data', apiKey: 'latest.student.share_firstgeneration', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'women_share', label: 'Women Share', category: 'Student Body', type: 'data', apiKey: 'latest.student.demographics.women', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'part_time_share', label: 'Part-Time Share', category: 'Student Body', type: 'data', apiKey: 'latest.student.part_time_share', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'international_share', label: 'International Share', category: 'Student Body', type: 'data', apiKey: 'latest.student.demographics.race_ethnicity.non_resident_alien', sortable: true, sortType: 'number', format: 'percent', keywords: ['international students'] },
  { id: 'asian_share', label: 'Asian Student Share', category: 'Student Body', type: 'data', apiKey: 'latest.student.demographics.race_ethnicity.asian', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'hispanic_share', label: 'Hispanic Student Share', category: 'Student Body', type: 'data', apiKey: 'latest.student.demographics.race_ethnicity.hispanic', sortable: true, sortType: 'number', format: 'percent' },
  { id: 'black_share', label: 'Black Student Share', category: 'Student Body', type: 'data', apiKey: 'latest.student.demographics.race_ethnicity.black', sortable: true, sortType: 'number', format: 'percent' },
];

const regionLabels = {
  0: 'U.S. Service Schools',
  1: 'New England',
  2: 'Mid East',
  3: 'Great Lakes',
  4: 'Plains',
  5: 'Southeast',
  6: 'Southwest',
  7: 'Rocky Mountains',
  8: 'Far West',
  9: 'Outlying Areas',
};

const localeLabels = {
  11: 'City, Large',
  12: 'City, Midsize',
  13: 'City, Small',
  21: 'Suburb, Large',
  22: 'Suburb, Midsize',
  23: 'Suburb, Small',
  31: 'Town, Fringe',
  32: 'Town, Distant',
  33: 'Town, Remote',
  41: 'Rural, Fringe',
  42: 'Rural, Distant',
  43: 'Rural, Remote',
};

const stateCenters = {
  AL: [32.8067, -86.7911], Alabama: [32.8067, -86.7911],
  AK: [61.3707, -152.4044], Alaska: [61.3707, -152.4044],
  AZ: [33.7298, -111.4312], Arizona: [33.7298, -111.4312],
  AR: [34.9697, -92.3731], Arkansas: [34.9697, -92.3731],
  CA: [36.1162, -119.6816], California: [36.1162, -119.6816],
  CO: [39.0598, -105.3111], Colorado: [39.0598, -105.3111],
  CT: [41.5978, -72.7554], Connecticut: [41.5978, -72.7554],
  DE: [39.3185, -75.5071], Delaware: [39.3185, -75.5071],
  FL: [27.7663, -81.6868], Florida: [27.7663, -81.6868],
  GA: [33.0406, -83.6431], Georgia: [33.0406, -83.6431],
  HI: [21.0943, -157.4983], Hawaii: [21.0943, -157.4983],
  ID: [44.2405, -114.4788], Idaho: [44.2405, -114.4788],
  IL: [40.3495, -88.9861], Illinois: [40.3495, -88.9861],
  IN: [39.8494, -86.2583], Indiana: [39.8494, -86.2583],
  IA: [42.0115, -93.2105], Iowa: [42.0115, -93.2105],
  KS: [38.5266, -96.7265], Kansas: [38.5266, -96.7265],
  KY: [37.6681, -84.6701], Kentucky: [37.6681, -84.6701],
  LA: [31.1695, -91.8678], Louisiana: [31.1695, -91.8678],
  ME: [44.6939, -69.3819], Maine: [44.6939, -69.3819],
  MD: [39.0639, -76.8021], Maryland: [39.0639, -76.8021],
  MA: [42.2302, -71.5301], Massachusetts: [42.2302, -71.5301],
  MI: [43.3266, -84.5361], Michigan: [43.3266, -84.5361],
  MN: [45.6945, -93.9002], Minnesota: [45.6945, -93.9002],
  MS: [32.7416, -89.6787], Mississippi: [32.7416, -89.6787],
  MO: [38.4561, -92.2884], Missouri: [38.4561, -92.2884],
  MT: [46.9219, -110.4544], Montana: [46.9219, -110.4544],
  NE: [41.1254, -98.2681], Nebraska: [41.1254, -98.2681],
  NV: [38.3135, -117.0554], Nevada: [38.3135, -117.0554],
  NH: [43.4525, -71.5639], 'New Hampshire': [43.4525, -71.5639],
  NJ: [40.2989, -74.5210], 'New Jersey': [40.2989, -74.5210],
  NM: [34.8405, -106.2485], 'New Mexico': [34.8405, -106.2485],
  NY: [42.1657, -74.9481], 'New York': [42.1657, -74.9481],
  NC: [35.6301, -79.8064], 'North Carolina': [35.6301, -79.8064],
  ND: [47.5289, -99.7840], 'North Dakota': [47.5289, -99.7840],
  OH: [40.3888, -82.7649], Ohio: [40.3888, -82.7649],
  OK: [35.5653, -96.9289], Oklahoma: [35.5653, -96.9289],
  OR: [44.5720, -122.0709], Oregon: [44.5720, -122.0709],
  PA: [40.5908, -77.2098], Pennsylvania: [40.5908, -77.2098],
  RI: [41.6809, -71.5118], 'Rhode Island': [41.6809, -71.5118],
  SC: [33.8569, -80.9450], 'South Carolina': [33.8569, -80.9450],
  SD: [44.2998, -99.4388], 'South Dakota': [44.2998, -99.4388],
  TN: [35.7478, -86.6923], Tennessee: [35.7478, -86.6923],
  TX: [31.0545, -97.5635], Texas: [31.0545, -97.5635],
  UT: [40.1500, -111.8624], Utah: [40.1500, -111.8624],
  VT: [44.0459, -72.7107], Vermont: [44.0459, -72.7107],
  VA: [37.7693, -78.1700], Virginia: [37.7693, -78.1700],
  WA: [47.4009, -121.4905], Washington: [47.4009, -121.4905],
  WV: [38.4912, -80.9545], 'West Virginia': [38.4912, -80.9545],
  WI: [44.2685, -89.6165], Wisconsin: [44.2685, -89.6165],
  WY: [42.7560, -107.3025], Wyoming: [42.7560, -107.3025],
};

function readMyInfoPersonal() {
  try {
    return JSON.parse(userStorage.getItem('my_info_personal') || '{}');
  } catch (error) {
    return {};
  }
}

function toRadians(value) {
  return Number(value) * (Math.PI / 180);
}

function getMilesBetween(lat1, lon1, lat2, lon2) {
  const earthRadiusMiles = 3958.8;
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  return earthRadiusMiles * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function getHomeAnchor() {
  const personalInfo = readMyInfoPersonal();
  const locationValue = personalInfo.homeCity || personalInfo.stateOfResidence;
  if (!locationValue) return null;

  const stateValue = personalInfo.stateOfResidence?.trim();
  if (!stateValue) return null;
  return stateCenters[stateValue] || stateCenters[stateValue.toUpperCase()] || null;
}

export function createCustomColumn(label, customType = 'text', labels = []) {
  const trimmedLabel = label.trim().replace(/\s+/g, ' ');
  if (!trimmedLabel) return null;
  const hasOptions = CUSTOM_FIELD_TYPES_WITH_OPTIONS.includes(customType);
  const normalizedLabels = hasOptions
    ? Array.from(new Set(labels.map((option) => option.trim()).filter(Boolean)))
    : [];

  return {
    id: `custom_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    label: trimmedLabel,
    category: CUSTOM_FIELD_CATEGORY,
    type: 'custom',
    isBuiltIn: false,
    customType,
    labels: hasOptions && normalizedLabels.length === 0 ? ['Option 1'] : normalizedLabels,
    sortable: true,
    sortType: customType === 'number' ? 'number' : 'string',
  };
}

export function getAllColumnOptions(customColumns = []) {
  return [
    ...customColumns.map((column) => {
      const builtInDefault = DEFAULT_CUSTOM_COLUMNS.find((defaultColumn) => defaultColumn.id === column.id);
      const isBuiltIn = Boolean(column.isBuiltIn || builtInDefault);
      return {
        ...column,
        label: builtInDefault?.label || column.label,
        category: isBuiltIn ? CUSTOM_TRACKING_CATEGORY : (column.category || CUSTOM_FIELD_CATEGORY),
        type: 'custom',
        isBuiltIn,
        customType: builtInDefault?.customType || column.customType || 'text',
        labels: builtInDefault?.labels || column.labels || [],
        sortable: column.sortable !== false,
        sortType: builtInDefault?.sortType || column.sortType || (column.customType === 'number' ? 'number' : 'string'),
      };
    }),
    ...COLUMN_OPTIONS,
  ];
}

export const getColDef = (colId, customColumns = []) =>
  getAllColumnOptions(customColumns).find((column) => column.id === colId);

export function getCollegeApiFields() {
  const fields = new Set(['id']);
  COLUMN_OPTIONS.forEach((column) => {
    if (column.apiKey) fields.add(column.apiKey);
    if (column.apiKeys) column.apiKeys.forEach((key) => fields.add(key));
  });
  return Array.from(fields).join(',');
}

function hasValue(value) {
  return value !== null && value !== undefined && value !== '';
}

export function parseNumericSortValue(value, colDef = {}) {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (!hasValue(value)) return null;

  const text = String(value).trim().replace(/\u2212/g, '-');
  if (!text || /^(?:n\/?a|na|none|null|unknown|—|-)$/i.test(text)) return null;

  const matches = text.match(/[-+]?(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?/g);
  if (!matches?.length) return null;

  const usesHighEnd = colDef.format === 'satRange' || colDef.format === 'actRange';
  const token = usesHighEnd ? matches[matches.length - 1] : matches[0];
  let numericValue = Number(token.replace(/,/g, ''));
  if (!Number.isFinite(numericValue)) return null;

  if (/^\(.*\)$/.test(text)) numericValue = -Math.abs(numericValue);

  const suffix = text.match(/([kmb])\s*$/i)?.[1]?.toLowerCase();
  if (suffix === 'k') numericValue *= 1_000;
  if (suffix === 'm') numericValue *= 1_000_000;
  if (suffix === 'b') numericValue *= 1_000_000_000;

  const isPercent = text.includes('%') || colDef.format === 'percent';
  if (isPercent && (text.includes('%') || Math.abs(numericValue) > 1)) numericValue /= 100;

  return numericValue;
}

export function compareColumnSortValues(valueA, valueB, colDef, direction = 'asc') {
  const normalizedA = colDef.sortType === 'number' ? parseNumericSortValue(valueA, colDef) : valueA;
  const normalizedB = colDef.sortType === 'number' ? parseNumericSortValue(valueB, colDef) : valueB;

  if (normalizedA == null && normalizedB == null) return 0;
  if (normalizedA == null) return 1;
  if (normalizedB == null) return -1;

  const comparison = colDef.sortType === 'number'
    ? normalizedA - normalizedB
    : String(normalizedA).localeCompare(String(normalizedB));
  return direction === 'asc' ? comparison : -comparison;
}

function formatCurrency(value) {
  if (!hasValue(value) || Number.isNaN(Number(value))) return '—';
  return `$${Number(value).toLocaleString()}`;
}

function formatPercent(value) {
  if (!hasValue(value) || Number.isNaN(Number(value))) return '—';
  return `${(Number(value) * 100).toFixed(1)}%`;
}

function formatInteger(value) {
  if (!hasValue(value) || Number.isNaN(Number(value))) return '—';
  return Number(value).toLocaleString();
}

function sumValues(schoolData, keys) {
  const values = keys.map((key) => schoolData?.[key]);
  if (values.some((value) => !hasValue(value) || Number.isNaN(Number(value)))) return null;
  return values.reduce((sum, value) => sum + Number(value), 0);
}

export function getRawSortValue(colDef, row) {
  if (colDef.id === 'category') return row.category || '';
  if (colDef.id === 'date') return row.date || '';
  if (colDef.type === 'custom') {
    const value = row.customFields?.[colDef.id];
    if (colDef.customType === 'checkbox') return value ? 1 : 0;
    if (colDef.customType === 'number') return parseNumericSortValue(value, colDef);
    return value || '';
  }

  const schoolData = row.schoolData;
  if (colDef.format === 'satRange' || colDef.format === 'satSum') {
    return sumValues(schoolData, colDef.apiKeys?.slice(-2) || []);
  }
  if (colDef.format === 'actRange') {
    const high = schoolData?.['latest.admissions.act_scores.75th_percentile.cumulative'];
    return hasValue(high) ? Number(high) : null;
  }
  if (colDef.format === 'firstCurrency') {
    const value = colDef.apiKeys.map((key) => schoolData?.[key]).find(hasValue);
    return hasValue(value) ? Number(value) : null;
  }
  if (colDef.format === 'distanceFromHome') {
    const homeAnchor = getHomeAnchor();
    const schoolLat = schoolData?.['location.lat'];
    const schoolLon = schoolData?.['location.lon'];
    if (!homeAnchor || !hasValue(schoolLat) || !hasValue(schoolLon)) return null;
    return getMilesBetween(homeAnchor[0], homeAnchor[1], Number(schoolLat), Number(schoolLon));
  }
  if (colDef.apiKey) {
    return schoolData?.[colDef.apiKey] ?? null;
  }
  return null;
}

export function formatValue(colDef, schoolData) {
  if (!schoolData || typeof schoolData !== 'object') return '—';

  if (colDef.format === 'satSum') {
    const total = sumValues(schoolData, colDef.apiKeys);
    return total == null ? '—' : String(total);
  }

  if (colDef.format === 'satRange') {
    const low = sumValues(schoolData, colDef.apiKeys.slice(0, 2));
    const high = sumValues(schoolData, colDef.apiKeys.slice(2));
    return low == null || high == null ? '—' : `${low}-${high}`;
  }

  if (colDef.format === 'actRange') {
    const low = schoolData[colDef.apiKeys[0]];
    const high = schoolData[colDef.apiKeys[1]];
    return !hasValue(low) || !hasValue(high) ? '—' : `${low}-${high}`;
  }

  if (colDef.format === 'firstCurrency') {
    const value = colDef.apiKeys.map((key) => schoolData[key]).find(hasValue);
    return formatCurrency(value);
  }

  if (colDef.format === 'distanceFromHome') {
    const personalInfo = readMyInfoPersonal();
    if (!personalInfo.homeCity && !personalInfo.stateOfResidence) {
      return 'Enter your location in My Info';
    }

    const homeAnchor = getHomeAnchor();
    const schoolLat = schoolData['location.lat'];
    const schoolLon = schoolData['location.lon'];
    if (!homeAnchor || !hasValue(schoolLat) || !hasValue(schoolLon)) return '—';

    const miles = getMilesBetween(homeAnchor[0], homeAnchor[1], Number(schoolLat), Number(schoolLon));
    return `About ${Math.round(miles).toLocaleString()} mi`;
  }

  if (!colDef.apiKey) return '—';
  const value = schoolData[colDef.apiKey];
  if (!hasValue(value)) return '—';

  if (colDef.format === 'percent') return formatPercent(value);
  if (colDef.format === 'currency') return formatCurrency(value);
  if (colDef.format === 'integer') return formatInteger(value);
  if (colDef.format === 'decimal') return Number(value).toFixed(4);
  if (colDef.format === 'degree') return degreeLabels[value] || String(value);
  if (colDef.format === 'schoolType') return schoolTypeLabels[value] || String(value);
  if (colDef.format === 'region') return regionLabels[value] || String(value);
  if (colDef.format === 'locale') return localeLabels[value] || String(value);
  if (colDef.format === 'yesNo') return Number(value) === 1 ? 'Yes' : 'No';
  if (colDef.format === 'testOptional') {
    const numericValue = Number(value);
    if (numericValue === 1 || numericValue === 2) return 'No';
    if (numericValue === 3 || numericValue === 5) return 'Yes';
    return 'Not reported';
  }

  return String(value);
}

export function groupColumns(columns) {
  return columns.reduce((groups, column) => {
    const category = column.category || 'Other';
    if (!groups[category]) groups[category] = [];
    groups[category].push(column);
    return groups;
  }, {});
}

export function filterColumns(columns, searchValue) {
  const query = searchValue.trim().toLowerCase();
  if (!query) return columns;

  return columns.filter((column) => {
    const haystack = [
      column.label,
      column.category,
      column.apiKey,
      ...(column.apiKeys || []),
      ...(column.keywords || []),
    ].filter(Boolean).join(' ').toLowerCase();
    return haystack.includes(query);
  });
}
